import { ENV } from "../utils/constants";
import api from "./api";

export const listUsers = async () => {
  const response = await api.get(
    `account-settings-p1-${ENV}/crm/account-settings/company/users`
  );
  return response;
};

export const listRoles = async () => {
  const response = await api.get(
    `account-settings-p1-${ENV}/crm/account-settings/roles`
  );
  return response;
};

export const listCompanyPermissions = async () => {
  const response = await api.get(
    `account-settings-p1-${ENV}/crm/account-settings/company/permissions`
  );
  console.log("Permisssions: ", response);
  return response;
};

export const postAddUser = async (data : any) => {
  const response = await api.post(
    `account-settings-p1-${ENV}/crm/account-settings/company/user/new`,
    data
  );

  return response;
};

export const getEdtUser = async (id : number) => {
  const response = await api.get(
    `account-settings-p1-${ENV}/crm/account-settings/company/user/${id}`
  );
  return response;
};

export const putEdtUser = async (data: any, id: number) => {
  const response = await api.put(
    `account-settings-p1-${ENV}/crm/account-settings/company/user/edit/${id}`,
    data
  );
  console.log('response update: ', response)
  return response;
};

export const disableUser = async (userId: any): Promise<any> => {
  try {
    const { data } = await api.put(
      `account-settings-p1-${ENV}/crm/account-settings/company/user/disable/${userId}`
    );

    return data;
  } catch (err) {
    return err;
  }
};
